import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [vip首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401145
export const homepage = createAsyncThunk(
  '/live/vip/homepage',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/vip/homepage',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

export enum StatusEnum {
  正常 = 0,
  不是vip = 1,
  卡级 = 2,
  封禁 = 3,
  满级 = 4,
  即将到期 = 5,
}
export interface InitialStateType {
  privilege_list?: Array<{
    id: number
    title: string
    icon: string
    lock_icon: string
    lock_level: number
    desc: string
    image: string
    count_map?: {
      [key: number]: number
    }
    scheme?: string
  }>
  level_map?: {
    [key: number]: null
  }
  user_info?: {
    name: string
    avatar: string
    level: number
    exp: number
    expire_date: string
    expire_year: string
    expire_month: string
    expire_day: string
    bubble: string
    status: StatusEnum
    is_birth_day: boolean
  }
  toast?: string
  ari_discount_popup?: boolean // 贵族折扣是否弹窗
}

const initialState: InitialStateType = {}

export const VipSlice = createSlice({
  name: 'VipSlice',
  initialState,
  reducers: {
    // applyFace: (state, action: PayloadAction<boolean>) => {
    //   Object.assign(state, {
    //     is_apply: true,
    //   })
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default VipSlice.reducer
export const VipActions = VipSlice.actions

export const useVipState = () => {
  const data = useSelector((state) => {
    return state.Vip
  })
  return data
}
